import { useTranslation } from "react-i18next";
import {
  Button,
  Checkbox,
  Col,
  Form,
  message,
  Modal,
  Radio,
  Row,
  Space,
  TableColumnsType,
  TableProps,
  Typography
} from 'antd'
import React, {useEffect, useState} from 'react'
import FormInput from '../../form-input/FormInput'
import {CheckCircleOutlined, SearchOutlined} from '@ant-design/icons'
import TableData from '../../table-data/TableData'
import FormItemDropdown from '../../form-dropdown/FormItemDropdown'
import {useParams} from 'react-router-dom'
import {isEmpty} from 'lodash'
import {
  copyTemplateUnit,
  getAllSectionByCourseId,
  getListSequenceById,
  getSequenceBySection
} from '../../../service/content-list-course/contentListCourseApi'
import {formatDate} from '../../../utils/converDate'

type Props = {
  open: boolean
  handleClose: () => void
  getListDataProps: () => void
  searchValue: string;
  filterData: any;
  tab: string
}

export default function CopyTemplateUnitCourse(props: Props) {
  const { t } = useTranslation();
  const {open, handleClose, searchValue, tab, filterData, getListDataProps} = props
  const [sectionList, setSectionList] = useState<any>([])
  const [sequenceList, setSequenceList] = useState<any>([])

  const [listData, setListData] = useState<any>([])
  const [pageNumber, setPageNumber] = useState<number>(1)
  const [pageSize, setPageSize] = useState<number>(10)
  const [totalRecords, setTotalRecords] = useState<number>(0)
  const [loading, setLoading] = useState<boolean>(false)
  const [statusOrder, setStatusOrder] = useState<string>("")
  const [selectedRowKeys, setSelectedRowKeys] = useState<any>([])
  const [searchValueSynPopup, setSearchValueSynPopup] = useState<string>('')
  const [clearRowkey, setClearRowkey] = useState<boolean>(false);

  const params = useParams()
  const CheckboxGroup = Checkbox.Group;
  const [form] = Form.useForm()

  const validations = {
    sectionName: {
      required: true,
      message: t("Vui lòng chọn chương", "Vui lòng chọn chương"),
    },
    sequenceName: {
      required: true,
      message: t("Vui lòng nhập tên bài giảng", "Vui lòng nhập tên bài giảng"),
    },
    unitName: [
      {
        required: true,
        message: t("Vui lòng nhập tên học liệu", "Vui lòng nhập tên học liệu"),
      },
      {
        max: 255,
        message: t("Tiêu đề không vượt quá 255 kí tự", "Tiêu đề không vượt quá 255 kí tự"),
      }
    ],
  };

  const dataColumnsLesson: TableColumnsType<any> = [
    {
      title: "STT",
      dataIndex: "stt",
      key: "stt",
      width: 10,
      render: (_: any, record, index) => {
        return <div>{record?.numericalOrder ?? 1}</div>;
      },
    },
    {
      title: t("Đánh giá", "Đánh giá"),
      dataIndex: "name",
      key: "name",
      sorter: true,
      width: 20,
    },
    {
      title: t("Loại đánh giá", "Loại đánh giá"),
      dataIndex: "sequence",
      key: "sequence",
      width: 20,
      render: (_: any, record) => {
        return <>{record.reviewType === 1 ? t("Bài tập", "Bài tập") : (record.reviewType === 2 ? t("Bài kiểm tra", "Bài kiểm tra") : t("Bài thi", "Bài thi"))}</>;
      },
    },
    {
      title: t("Trạng thái", "Trạng thái"),
      dataIndex: "status",
      key: "status",
      width: 20,
      render: (_: any, record) => {
        return <>{t("Công khai", "Công khai")}</>;
      },
    },
    {
      title: t("Ngày xuất bản", "Ngày xuất bản"),
      dataIndex: "publishDate",
      key: "publishDate",
      width: 20,
      render: (_: any, record) => {
        return <>{isEmpty(record.publishedDate) ? null : formatDate(record.publishedDate ?? '')}</>;
      },
    },
    {
      title: t("Ngày bắt đầu", "Ngày bắt đầu"),
      dataIndex: "startDate",
      key: "startDate",
      width: 20,
      render: (_: any, record) => {
        return <>{isEmpty(record.startedDate) ? null : formatDate(record.startedDate ?? '')}</>;
      },
    },
  ]

  const handleTableChange: TableProps["onChange"] = (
    pagination,
    filters,
    sorter: any
  ) => {
    const data =
      sorter.order === "ascend"
        ? "asc"
        : sorter.order === "descend"
          ? "desc"
          : "";
    setStatusOrder(data);
  };

  const getDataSectionByid = async () => {
    const data = {
      courseId: Number(params?.id) ?? 0,
      type: tab === '3' ? 3 : 5,
      keyword: searchValueSynPopup.trim(),
      sectionId: tab === "1" ? null : Number(filterData.sectionId),
      sequenceId: tab === "1" || tab === '2' ? null : Number(filterData.sequenceId),
      startedDateFrom: isEmpty(filterData.planCreationDate) ? filterData.planCreationDate?.[0] : null,
      startedDateTo: isEmpty(filterData.planCreationDate) ? filterData.planCreationDate?.[0] : null,
      publishedDateFrom: isEmpty(filterData.planApprovalDate) ? filterData.planApprovalDate?.[1] : null,
      publishedDateTo: isEmpty(filterData.planApprovalDate) ? filterData.planApprovalDate?.[1] : null,
      availableStatus: filterData.availableStatus ?? null,
      sortByName: statusOrder,
      page: pageNumber,
      size: pageSize
    }
    await getListSequenceById(data).then((res: any) => {
      setListData(res.data?.body?.content)
      setTotalRecords(res.data?.body?.totalElements)
    })
  }

  const getAllSection = async () => {
    await getAllSectionByCourseId(params?.id).then((res) => {
      setSectionList(res.data)
    })
  }

  const getListSequenceBySection = async (value: string) => {
    form.setFieldValue('sequenceName', null)
    await getSequenceBySection(value).then((res) => {
      setSequenceList(res.data)
    })
  }

  const getListData = async () => {
    getDataSectionByid()
  };

  const saveData = async (values: any) => {
    const data = {
      unitId: selectedRowKeys[0]?.id,
      sectionId: values.sectionName,
      sequenceId: values.sequenceName,
      name: values.unitName,
      description: values.description,
    }

    await copyTemplateUnit(data).then((res) => {
      if (res.status === 200) {
        message.success(t("Tạo bản sao học liệu thành công", "Tạo bản sao học liệu thành công"))
        form.resetFields()
        handleClose()
        getListDataProps()
        setClearRowkey(true)
      }
    })
  }

  useEffect(() => {
    getListData();
    getAllSection()
    if (!open) {
      setSearchValueSynPopup("")
      setSelectedRowKeys([])
      form.resetFields()
    }
    // if (!isEmpty(searchValue)) {
    //   setSearchValueSynPopup(searchValue)
    // }
  }, [open, pageNumber, statusOrder, pageSize]);

  return (
    <Form.Provider onFormFinish={async (name, {values, forms}) => {
      if (name === 'copy-template-course-modal') {
        if (isEmpty(selectedRowKeys)) {
          message.error(t("Bạn chưa chọn học liệu để tạo bản sao", "Bạn chưa chọn học liệu để tạo bản sao"))
          return
        }

        Modal.confirm({
          title: `Xác nhận tạo bản sao học liệu`,
          content: `Xin vui lòng xác nhận tạo bản sao học liệu.`,
          onOk: () => {
            saveData(values);
          },
          okText: t("Xác nhận", "Xác nhận"),
          cancelText: t("Đóng", "Đóng"),
          centered: true,
          icon: <CheckCircleOutlined style={{color: "#1677FF"}}/>,
          footer: (_, {OkBtn, CancelBtn}) => (
            <>
              <CancelBtn/>
              <OkBtn/>
            </>
          ),
        });
      }
    }}>

      <Modal
        className="copy-template-content-course-modal"
        title={t("Tạo bản sao học liệu", "Tạo bản sao học liệu")}
        closeIcon={true}
        centered
        open={open}
        onCancel={handleClose}
        footer={null}
        width={"80%"}
      >
        <Form
          form={form}
          name="copy-template-course-modal"
          layout="vertical"
        >
          <Row gutter={40} className='p-6'>
            <Col md={{span: 16}} lg={{span: 16}} xl={{span: 16}} xs={{span: 16}}>
              <Form.Item name="search">
                <FormInput
                  placeholder={t("Nhập từ khoá cần tìm", "Nhập từ khoá cần tìm")}
                  value={searchValueSynPopup}
                  onChange={(e: any) => setSearchValueSynPopup(e.target?.value)}
                  onKeyPress={(e: any) => setSearchValueSynPopup(e.target?.value)}
                  afterPrefixIcon={<SearchOutlined className='cursor-pointer' onClick={getListData}/>}
                />
              </Form.Item>

              <TableData
                dataTable={listData}
                selectOneRow={true}
                dataColumns={dataColumnsLesson}
                setPageNumber={setPageNumber}
                setPageSize={setPageSize}
                pageNumber={pageNumber}
                pageSize={pageSize}
                loadingTable={loading}
                scroll={{x: 1500, y: 600}}
                totalRecords={totalRecords}
                handleTableChangeProps={handleTableChange}
                setSelectedRowKeysProps={setSelectedRowKeys}
                rowSelected={selectedRowKeys}
                pagination={true}
                hideSelection={true}
                clearRowkey={clearRowkey}
              />
            </Col>
            <Col md={{span: 8}} lg={{span: 8}} xl={{span: 8}} xs={{span: 8}}>
              <Typography.Title level={5}>{t("Thông tin học liệu", "Thông tin học liệu")}</Typography.Title>
              <div>
                <Form.Item name="sectionName" label={t("Tên chương", "Tên chương")} rules={[validations.sectionName]}>
                  <FormItemDropdown placeholder={t("Chọn chương", "Chọn chương")} onChange={getListSequenceBySection}
                                    options={sectionList}/>
                </Form.Item>

                <Form.Item name="sequenceName" className='mt-2' rules={[validations.sequenceName]}
                           label={t("Tên bài giảng", "Tên bài giảng")}>
                  <FormItemDropdown placeholder={t("Chọn bài giảng", "Chọn bài giảng")}
                                    options={sequenceList}/>
                </Form.Item>

                <Form.Item name="unitName" label={t("Tên học liệu", "Tên học liệu")} rules={validations.unitName} className='mt-2'>
                  <FormInput placeholder={t("Nhập tên học liệu", "Nhập tên học liệu")}/>
                </Form.Item>

                <Form.Item name="description" label={t("Mô tả", "Mô tả")} className='mt-2'>
                  <FormInput placeholder={t("Nhập mô tả", "Nhập mô tả")}/>
                </Form.Item>

                <Typography.Title level={5} className='mt-2'>{t("Trạng thái", "Trạng thái")}</Typography.Title>
                <Form.Item>
                  <Radio checked>{t("Bản nháp", "Bản nháp")}</Radio>
                </Form.Item>
                <p>{t("Phần này sẽ không được người dùng nhìn thấy", "Phần này sẽ không được người dùng nhìn thấy")}</p>
              </div>

              <div className='mt-9'>
                <Space className='float-right'>
                  <Button onClick={handleClose} className="btn btn-outlined">
                    <Typography.Text>
                      {t("Hủy", "Hủy")}
                    </Typography.Text>
                  </Button>
                  <Button className="btn btn-primary" onClick={() => form.submit()}
                  >
                    <Typography.Text>
                      {t("Lưu", "Lưu")}
                    </Typography.Text>
                  </Button>
                </Space>
              </div>
            </Col>
          </Row>
        </Form>
      </Modal>
    </Form.Provider>
  )
}
